import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ErrorDisplayModule } from '@precisely/prism-ng/error-display';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressSpinnerComponent } from './progress-spinner/progress-spinner.component';
import { UserProfileMappingComponent } from '../idp-configuration/idp-configuration/user-profile-mapping/user-profile-mapping.component';
import { IdpSummaryComponent } from '../idp-configuration/idp-configuration/idp-summary/idp-summary.component';
import { FieldsetModule } from 'primeng/fieldset';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';

@NgModule({
  declarations: [
    ProgressSpinnerComponent,
    UserProfileMappingComponent,
    IdpSummaryComponent,
  ],
  imports: [
    CommonModule,
    DynamicDialogModule,
    ErrorDisplayModule,
    ProgressSpinnerModule,
    FieldsetModule,
    CardModule,
    FileUploadModule,
    InputTextModule,
  ],
  exports: [
    ProgressSpinnerComponent,
    IdpSummaryComponent,
    UserProfileMappingComponent,
  ],
  providers: [DialogService],
})
export class SharedModule {}
